import { API_BASE_URL } from '@synergy/config';
import { Box, Stack, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PoolButton, PoolLink, PoolTypography } from '@synergy/components-next';
import { PoolFormattedMessage } from '@synergy/components-next';
import { ReactElement } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

import { LoginApi } from '../common/api/login-api';
import Footer from '../common/components/footer/footer';

const Content = styled(Stack)(({ theme }) => ({
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexGrow: 1,
    paddingTop: '20vh',

    [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(8),
    },
}));

const InnerContent = styled(Box)(() => ({
    maxWidth: 300,
}));

export const ForgotPasswordSuccess = (): ReactElement => {
    const navigate = useNavigate();
    const location = useLocation();
    const { email } = useParams();

    const forgotPasswordApi = new LoginApi(API_BASE_URL);

    if (!email) {
        navigate({ pathname: '..', search: location.search });
    }

    const handleBackToLogin = (): void => {
        navigate({ pathname: '/', search: location.search });
    };

    const handleResendMessage = () => {
        if (email) {
            forgotPasswordApi.requestResetPassword(email);
        }
    };

    return (
        <>
            <Content>
                <InnerContent>
                    <Stack
                        typography="body1"
                        justifyContent="flex-start"
                        textAlign="center"
                        alignSelf="flex-start"
                        gap={2}
                        sx={{ width: theme => theme.spacing(37.5) }}
                    >
                        <PoolTypography component="div" variant="h4" translationId="app.gotEmail.title" />
                        <Box>
                            <PoolFormattedMessage id="app.gotEmail.subtitle1" values={{ email }} />
                        </Box>
                        <Box color="grey.800">
                            <PoolFormattedMessage id="app.gotEmail.subtitle2" />
                        </Box>

                        <PoolButton
                            variant="contained"
                            type="submit"
                            fullWidth={true}
                            onClick={handleBackToLogin}
                            sx={{ mt: 2 }}
                        >
                            <FormattedMessage id="app.gotEmail.backToLogin" />
                        </PoolButton>
                    </Stack>
                </InnerContent>
            </Content>
            <Footer>
                <FormattedMessage id="app.gotEmail.noEmail" />
                <PoolLink colorVariant="primary2" underline="none" onClick={handleResendMessage}>
                    <FormattedMessage id="app.gotEmail.resendEmail" />
                </PoolLink>
            </Footer>
        </>
    );
};
